<template>
  <div class="page products-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">
      下面按石斛系列与天麻系列列出六款规格产品，卡片可直接看到净含量、袋数与配料，
      参数取自各 SKU 的现行包装标签。先选要了解的那一款，再往下看逐项对照表；
      本站不公布价格，购买渠道与检测资料可以按文末方式查询。
    </p>

    <h2 class="section-heading">按系列浏览</h2>
    <ProductCatalog section-id="products" />
    <p class="packaging-note">
      三七、灵芝与精油系列尚无已确认可公开的包装资料，目录里不列空分类；
      需要了解时可通过下方方式查询。
    </p>

    <h2 class="section-heading">参数对照表</h2>
    <div class="table-scroll">
      <table class="compare-table">
        <caption class="visually-hidden">滋仙草各规格产品的净含量、配料、保质期、贮存条件与食用方法对照</caption>
        <thead>
          <tr>
            <th scope="col">产品</th>
            <th scope="col">规格</th>
            <th scope="col">配料</th>
            <th scope="col">保质期</th>
            <th scope="col">贮存条件</th>
            <th scope="col">食用方法</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="facts in productFacts" :key="facts.id">
            <th scope="row"><a :href="`/products/${facts.id}.html`">{{ facts.shortName }}</a></th>
            <td>{{ facts.spec[0] }}（{{ facts.spec[1] }}）</td>
            <td>{{ facts.ingredients }}</td>
            <td>{{ facts.shelfLife }}</td>
            <td>{{ facts.storage }}</td>
            <td>{{ facts.method }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="packaging-note">
      以上为各 SKU 包装标签上的标示值，不同批次包装细节可能不同。石斛多糖、甘露糖等成分标示值只在对应产品页给出，
      不在不同原料品种之间比较高低。
    </p>

    <h2 class="section-heading">购买与资料查询</h2>
    <p>
      本站不公布价格与促销信息。购买渠道、当期规格与检测报告等资料，可拨打服务热线
      <a href="tel:4008317518">400-831-7518</a>，或<a href="/contact.html">查看联系我们</a>、
      <a href="/faq.html">常见问题</a>。
    </p>
    <ContactFriend placement="hero" />
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import ProductCatalog from '@/components/ProductCatalog.vue'
import { resolvePage } from '@/content/siteContent.mjs'
import { productFacts } from '@/config/productFacts'

const page = resolvePage('/products.html')

export default {
  name: 'ProductsPage',
  components: {
    ContactFriend,
    ProductCatalog
  },
  data() {
    return { page, productFacts }
  }
}
</script>

<style scoped>
.page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

.section-heading {
  color: #4b0082;
  font-size: 1.15em;
  margin: 26px 0 10px;
}

.page-intro,
p {
  color: #333;
  line-height: 1.8;
  margin: 0 0 16px;
}

.table-scroll {
  overflow-x: auto;
}

.compare-table {
  border-collapse: collapse;
  width: 100%;
  min-width: 720px;
  font-size: 0.92em;
}

.compare-table th,
.compare-table td {
  border: 1px solid #e3daee;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
  line-height: 1.7;
  color: #333;
}

.compare-table thead th {
  background: #f5f0ff;
  color: #4b0082;
}

.compare-table tbody th a {
  color: #4b0082;
}

.packaging-note {
  color: #666;
  font-size: 0.9em;
  margin: 10px 0 0;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
